import { useEffect, useRef, useState } from "react";

/* global __APP_VERSION__ */
// Versão embutida no build (vite define). Comparada com build/version.json
// (no-cache) servido pelo Hosting; se divergir, um deploy novo saiu → oferece
// recarregar.
//
// O gatilho é o semver porque o incremento é GARANTIDO: o bump roda no hook
// predeploy do hosting (firebase.json), antes do build, em todo deploy — e se
// ele falhar, o Firebase aborta a publicação. Antes o bump vivia só dentro dos
// deploy-hosting*.sh, então publicar por outro caminho pulava o incremento em
// silêncio e o banner nunca disparava.
//
// O version.json também traz `build` (commit) e `deployedAt`, mas como
// metadado de rastreabilidade — responde "essa versão é qual commit?" — e não
// como gatilho.
const VERSAO_ATUAL = typeof __APP_VERSION__ !== "undefined" ? __APP_VERSION__ : "dev";
const INTERVALO_MS = 10 * 60 * 1000; // checa a cada 10 min

/**
 * Banner "Nova versão disponível" — resolve o caso do app antigo carregado numa aba
 * aberta (SPA não recarrega o JS ao navegar). Não força reload (evita interromper
 * formulários); o usuário clica em Atualizar. Some sozinho se não houver versão nova.
 */
export default function NovaVersaoBanner() {
  const [novaVersao, setNovaVersao] = useState(null);
  const checando = useRef(false);

  useEffect(() => {
    let ativo = true;

    const checar = async () => {
      if (checando.current || document.hidden) return;
      checando.current = true;
      try {
        const resp = await fetch(`/version.json?t=${Date.now()}`, { cache: "no-store" });
        if (!resp.ok) return;
        const { version } = await resp.json();
        if (ativo && version && version !== VERSAO_ATUAL) setNovaVersao(version);
      } catch (_) {
        // offline / erro de rede: ignora, tenta de novo no próximo ciclo
      } finally {
        checando.current = false;
      }
    };

    checar(); // 1ª checagem ao montar
    const id = setInterval(checar, INTERVALO_MS);
    const aoVoltarFoco = () => { if (!document.hidden) checar(); };
    document.addEventListener("visibilitychange", aoVoltarFoco);

    return () => {
      ativo = false;
      clearInterval(id);
      document.removeEventListener("visibilitychange", aoVoltarFoco);
    };
  }, []);

  if (!novaVersao) return null;

  return (
    <div
      role="status"
      style={{
        position: "fixed", bottom: 16, left: "50%", transform: "translateX(-50%)",
        zIndex: 99999, background: "#0d6efd", color: "#fff", padding: "10px 16px",
        borderRadius: 8, boxShadow: "0 2px 12px rgba(0,0,0,.25)", display: "flex",
        alignItems: "center", gap: 12, fontSize: 14, maxWidth: "92vw",
      }}
    >
      <span>Nova versão disponível ({novaVersao}). Atualize para receber as últimas melhorias.</span>
      <button
        type="button"
        onClick={() => window.location.reload()}
        style={{
          background: "#fff", color: "#0d6efd", border: "none", borderRadius: 6,
          padding: "6px 12px", fontWeight: 600, cursor: "pointer", whiteSpace: "nowrap",
        }}
      >
        Atualizar
      </button>
    </div>
  );
}
